import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { questKeys } from '../quests.keys';
import { updateTokenRewardsTransaction } from '../quests.service';
export const useUpdateTokenRewardsTransaction = ({ subdomain = getSubdomain(), questId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => updateTokenRewardsTransaction({ subdomain, data }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: questKeys.questRewards(subdomain, questId) });
        },
    });
};
